import React, {FC} from "react"
import styled, {css} from "styled-components"

import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import {Product} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"

const Wrapper = styled.div`
  ${({theme}) => css`
    display: inline-block;
    background-color: ${theme.colors.utility.highlight};
    border-radius: ${theme.border.radius.medium};
    padding: ${theme.spacing.half} ${theme.spacing.one};
  `}
`

interface Props extends WithPerkOrReward {
  product: Product
}

const RewardPrice: FC<Props> = ({isRewards, product}) => {
  if (!isRewards) {
    return null
  }

  return (
    <Wrapper>
      <Flex alignItems="center">
        <Label marginRight>
          <FormattedMessage id="perks.productSelect.rewardPrice.text" />
        </Label>
        <FormattedCurrency isCents={false} value={product.salePrice.value} currency={product.salePrice.currency} />
      </Flex>
    </Wrapper>
  )
}

export default withPerkOrReward(RewardPrice)
